import React from 'react';
import { Box } from '@mui/material';
import LogisticsDashboard from './LogisticsDashboard';

const RCADashboardPage = () => (
  <Box sx={{ px: 1.5, pb: 2 }}>
    <LogisticsDashboard />
  </Box>
);

export default RCADashboardPage;
